import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

// This page is now deprecated - redirect to appropriate locations
// SBOM -> Assessment Center SBOM tab
// Audit Logs -> Administration Audit tab
// CMDB/GRC -> ITSM CMDB tab

export default function Integrations() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');

  useEffect(() => {
    // Redirect based on tab parameter
    if (tab === 'sbom') {
      navigate('/assessment-center?tab=sbom', { replace: true });
    } else if (tab === 'audit') {
      navigate('/administration?tab=audit', { replace: true });
    } else if (tab === 'cmdb') {
      navigate('/itsm?tab=cmdb', { replace: true });
    } else {
      // Default redirect to Assessment Center SBOM
      navigate('/assessment-center?tab=sbom', { replace: true });
    }
  }, [navigate, tab]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <div className="animate-spin w-8 h-8 border-2 border-indigo-500 border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-zinc-400">Redirecting...</p>
      </div>
    </div>
  );
}
